<template>
    <el-tabs v-model="activeName" type="card" class="cls-tabs-content">
        <el-tab-pane label="部门管理" name="depmana"><DepMana></DepMana></el-tab-pane>
        <el-tab-pane label="职位管理" name="posmana"><PosMana></PosMana></el-tab-pane>
        <el-tab-pane label="职称管理" name="joblevelmana"><JobLevelMana></JobLevelMana></el-tab-pane>
        <el-tab-pane label="权限组（谨慎操作）" name="permissmana" ><PermissMana></PermissMana></el-tab-pane>
    </el-tabs>
</template>

<script>
    import DepMana from '../../components/sys/basic/DepMana'
    import PosMana from '../../components/sys/basic/PosMana'
    import JobLevelMana from '../../components/sys/basic/JobLevelMana'
    import PermissMana from '../../components/sys/basic/PermissMana'
    export default {
        name: "SysBasic",
        data(){
            return{
                activeName: 'depmana'
            }
        },
        components:{
            DepMana,
            PosMana,
            JobLevelMana,
            PermissMana
        }
    }
</script>

<style lang="less"  scoped>
    .cls-tabs-content {
        :deep(.el-tabs__content) {
            height:100%;
            display: flex;
            flex-flow:column;
        }
        :deep(.el-tab-pane) {
            height: calc(100% - 30px - 20px);
        }
        :deep(.el-tabs__item) {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            color: #616161;
        }
        :deep(.el-tabs__item.is-active) {
            color: deepskyblue;
            background-color: #F5F5F5;
            border-bottom-color: #F5F5F5;
        }
    }
</style>
